document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.site-header');
    const menuToggle = document.querySelector('.menu-toggle');
    const mainNavigation = document.querySelector('.main-navigation');
    const menuItemsWithChildren = document.querySelectorAll('.menu-item-has-children');
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

    // Menu mobile toggle
    if (menuToggle) {
        menuToggle.addEventListener('click', () => {
            const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
            menuToggle.setAttribute('aria-expanded', !isExpanded);
            mainNavigation.classList.toggle('active');
        });
    }

    // Dropdown functionality for all devices
    dropdownToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const parentItem = toggle.closest('.menu-item-has-children');

            // Fermer tous les autres sous-menus ouverts
            menuItemsWithChildren.forEach(otherItem => {
                if (otherItem !== parentItem && otherItem.classList.contains('sub-menu-active')) {
                    otherItem.classList.remove('sub-menu-active');
                    const otherIcon = otherItem.querySelector('.dropdown-icon');
                    if (otherIcon) {
                        otherIcon.classList.remove('chevron-up');
                        otherIcon.classList.add('chevron-down');
                    }
                }
            });

            // Basculer l'état du sous-menu actuel
            parentItem.classList.toggle('sub-menu-active');
            const icon = toggle.querySelector('.dropdown-icon');

            if (parentItem.classList.contains('sub-menu-active')) {
                icon.classList.remove('chevron-down');
                icon.classList.add('chevron-up');
            } else {
                icon.classList.remove('chevron-up');
                icon.classList.add('chevron-down');
            }
        });
    });

    // Empêcher les liens parents de s'activer, sur tous les appareils
    menuItemsWithChildren.forEach(item => {
        const link = item.querySelector('a');
        link.addEventListener('click', (e) => {
            // Toujours empêcher la navigation pour les éléments avec des enfants
            e.preventDefault();

            // Simuler un clic sur le toggle du dropdown
            const toggle = item.querySelector('.dropdown-toggle');
            if (toggle) {
                toggle.click();
            }
        });
    });

    // Click outside menu to close
    document.addEventListener('click', (e) => {
        // Fermer le menu mobile si on clique en dehors
        if (mainNavigation.classList.contains('active') &&
            !mainNavigation.contains(e.target) &&
            !menuToggle.contains(e.target)) {
            mainNavigation.classList.remove('active');
            menuToggle.setAttribute('aria-expanded', 'false');
        }

        // Fermer les sous-menus si on clique en dehors
        if (!e.target.closest('.menu-item-has-children')) {
            menuItemsWithChildren.forEach(item => {
                item.classList.remove('sub-menu-active');
                const icon = item.querySelector('.dropdown-icon');
                if (icon) {
                    icon.classList.remove('chevron-up');
                    icon.classList.add('chevron-down');
                }
            });
        }
    });
});
